class Prize{
    constructor({title = "", description = "", noOfWinners = 0, sponsor = "", image =  "", sponsorsLogo =  ""})
    {
       this.title = title,
       this.description = description,
       this.noOfWinners = noOfWinners,
       this.sponsor  = sponsor,
       this.image = image,
       this.sponsorsLogo = sponsorsLogo
    }

    static fromObject(prize)
    {
        return new Prize({
            title: prize.title || "",
            description: prize.description || "",
            noOfWinners: prize.noOfWinners || 0,
            sponsor: prize.sponsor || "",
            image: prize.image || "",
            sponsorsLogo: prize.sponsorsLogo || ""
        })
    }

    toObject(){
        return {
            title: this.title,
            description: this.description,
            noOfWinners: this.noOfWinners,
            sponsor: this.sponsor,
            image: this.image,
            sponsorsLogo: this.sponsorsLogo
        }
    }
}

export default Prize;